import styled from "styled-components";
import React from "react";

const YELLOW_GRADIENT_COLOR_DARK = "#D3A417";
const YELLOW_GRADIENT_COLOR_LIGHT = "#F3C23A";

const StyledGoldButton = styled.button`
  display: inline-flex;
  min-width: 60px;
  min-height: 24px;
  max-height: 24px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid var(--ads-v2-color-yellow-600);
  background: linear-gradient(
    135deg,
    ${YELLOW_GRADIENT_COLOR_LIGHT} 0%,
    ${YELLOW_GRADIENT_COLOR_DARK} 100%
  );
  color: var(--ads-v2-color-gray-900);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;

  &:hover,
  &:focus {
    filter: brightness(0.97);
    outline: none;
  }
`;

interface GoldUpgradeButtonProps {
  onClick: () => void;
  className?: string;
  "data-testid"?: string;
  children: React.ReactNode;
}

const GoldUpgradeButton: React.FC<GoldUpgradeButtonProps> = ({
  children,
  className,
  "data-testid": dataTestId,
  onClick,
}) => {
  return (
    <StyledGoldButton
      className={className}
      data-testid={dataTestId}
      onClick={onClick}
    >
      {children}
    </StyledGoldButton>
  );
};

export default GoldUpgradeButton;
